<template>
	<div>
		<el-dialog top="6vh" :model-value="modelValue" @close="closeSelector" width="600px" class="dialog-supplier"
			:destroy-on-close="isDestroy">
			<template #title>
				<div class="title flex">
					<div>{{ type === 1 ? "个人供应商" : "企业供应商" }}</div>
				</div>
			</template>
			<div class="supplier_content">
				<div class="supplier_content-header">
					<el-form :model="searchForm">
						<el-row :gutter="10">
							<el-col v-if="type === 1" :span="10">
								<el-form-item label="" prop="supplierName" label-width="0px">
									<el-input v-model="searchForm.supplierName" placeholder="请输入搜索内容" @input="onInput"
										clearable />
								</el-form-item>
							</el-col>
							<el-col v-else :span="14">
								<el-form-item label="" prop="supplierCodeName" label-width="0px">
									<el-input v-model="searchForm.supplierCodeName" placeholder="请输入搜索内容"
										@input="onInput" clearable />
								</el-form-item>
							</el-col>
							<el-col :span="type === 1 ? 7 : 10">
								<el-form-item label="" prop="provinceList" label-width="0px">
									<el-cascader ref="cascaderArr" v-model="searchForm.provinceList"
										placeholder="请选择所在地省/市/区" :options="areaList" :props="areaProps" filterable
										clearable style="width: 100%" @change="provinceChange" />
								</el-form-item>
							</el-col>
							<el-col :span="7" v-if="type === 1">
								<el-form-item label="" prop="supplierClassify" label-width="0px">
									<el-select v-model="searchForm.supplierClassify" filterable placeholder="请选择"
										style="width: 100%" clearable @change="classHandleChange">
										<el-option v-for="item in supplierClassifyList" :key="item.id"
											:label="item.name" :value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<div class="supplier_content-box" v-if="type === 1" v-loading="loading" v-infinite-scroll="load">
					<div class="card-box" v-for="(item, index) in cardList" :key="index">
						<div class="card-radio">
							<el-checkbox v-if="multiple" :value="item.checked" :label="item.id"
								@change="checkOnChange($event, item)">
								{{ "" }}
							</el-checkbox>
							<el-radio v-else :label="true" :value="item.checked" @change="checkOnChange($event, item)">
								{{ "" }}
							</el-radio>
						</div>
						<div class="portrait">
							{{ item.supplierName.slice(-2) }}
						</div>
						<div class="box-content">
							<p class="name">{{ item.supplierName }}_{{ item.sex === "1" ? "男" : "女" }}</p>
							<p class="detail">
								<span>{{ item.departmentName }}</span>
								<el-divider direction="vertical" />
								<span>{{ item.orgName }}</span>
							</p>
						</div>
					</div>
					<p class="bottom" v-if="noMore">暂无数据</p>
				</div>
				<div class="supplier_content-box" v-else v-infinite-scroll="load">
					<div class="card-box" v-for="(item, index) in cardList" :key="index">
						<div class="card-radio">
							<el-checkbox v-if="multiple" :value="item.checked" :label="item.id"
								@change="checkOnChange($event, item)">
								{{ "" }}
							</el-checkbox>
							<el-radio v-else :model-value="item.checked" :value="true" @change="checkOnChange($event, item)">
								{{ "" }}
							</el-radio>
						</div>
						<div class="portrait">
							{{ item.supplierName.slice(-2) }}
						</div>
						<div class="box-content">
							<p class="name">{{ item.supplierName }}</p>
							<p class="detail">
								<span>集团外供应商（个人/企业）</span>
								<el-divider direction="vertical" />
								<span>{{ item.supplierCode }}</span>
								<el-divider direction="vertical" />
								<span>{{ item.supplierShortName }}</span>
							</p>
						</div>
					</div>
					<p class="bottom" v-if="noMore">暂无数据</p>
				</div>
			</div>
			<template  #footer>
				<div class="flex justify-end items-center">
					<el-button @click="closeSelector">取消</el-button>
					<el-button type="primary" @click="submitHandleClick" :disabled="selectList.length === 0">确定</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script lang="ts" setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted, toRefs } from "vue";
import { getAreaList, getClientInit, queryPerSupplierList } from "../../../service/crm"
import { getSupplierList } from "../../../service/supplier"
function debounce(fn:any, delay:number) {
    let time:any = null;//time用来控制事件的触发
    return function () {
        if (time !== null) {
            clearTimeout(time);
        }
        time = setTimeout(() => {
			// @ts-ignore
            fn.call(this);
        }, delay)
    }
}


const emit = defineEmits(["cancel", "confirm"]);

type Props = {
	modelValue: boolean,
	multiple?: boolean,
	selectedList?: Array<any>,
	type?: number,
	isDestroy?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	modelValue: false,
	multiple: false,
	selectedList: () => {
		return []
	},
	// 1-个人 2-企业
	type: 1,
	isDestroy: false
})

const { modelValue, multiple, selectedList, type, isDestroy } = toRefs(props)

const searchForm = ref({
	auditState: "1",
	beginCreateDate: "",
	beginUpdateDate: "",
	cityCode: "",
	cityName: "",
	countyCode: "",
	endCreateDate: "",
	endUpdateDate: "",
	jobLevel: "",
	keyword: "",
	onwerType: "",
	pageNo: 1,
	pageSize: 30,
	totalPages: 0,
	provinceCode: "",
	provinceName: "",
	supplierClassify: "",
	supplierCode: "",
	supplierName: "",
	supplierCodeName: "",
	userId: "",
	provinceList: [],
})
const areaProps = reactive({
	value: "areaCode",
	label: "areaName",
	children: "list",
})
const loading = ref(false)
const noMore = ref(false)
const cardList:any = ref([])
const areaList:any = ref([])
const supplierClassifyList:any = ref([])
const selectList:any = ref([])

watch(() => selectedList.value, (newValue) => {
	selectList.value = newValue
}, {
	deep: true,
	immediate: true
})

watch(() => modelValue.value, (val) => {
	if (val && isDestroy.value) {
		searchForm.value = {
			auditState: "1",
			beginCreateDate: "",
			beginUpdateDate: "",
			cityCode: "",
			cityName: "",
			countyCode: "",
			endCreateDate: "",
			endUpdateDate: "",
			jobLevel: "",
			keyword: "",
			onwerType: "",
			pageNo: 1,
			pageSize: 30,
			totalPages: 0,
			provinceCode: "",
			provinceName: "",
			supplierClassify: "",
			supplierCode: "",
			supplierName: "",
			supplierCodeName: "",
			userId: "",
			provinceList: [],
		}
		console.log('selectList.value', selectList.value, selectedList.value);
		
		selectList.value = []
		searchData()
	}
}, {
	immediate: true
})

onMounted(async () => {
	await getAreaListData()
	await getClientInitData()
	if (!isDestroy.value) {
		searchForm.value.pageNo = 1
		await searchData()
	}
})

const load = () => {
	searchForm.value.pageNo++
	const realPageNumber = type.value === 1 ? searchForm.value.totalPages :  Math.ceil(searchForm.value.totalPages / searchForm.value.pageSize)
	if (searchForm.value.pageNo > realPageNumber) {
		console.log('searchForm.value.pageNo', searchForm.value.pageNo, realPageNumber);
		noMore.value = true
		return
	} else {
		console.log('searchForm.value.pageNo1', searchForm.value.pageNo, realPageNumber);
		noMore.value = false
	}
	type.value === 1 ? getPersonalData() : getEnterpriseData()
}

const searchData = () => {
	cardList.value = []
	type.value === 1 ? getPersonalData() : getEnterpriseData()
}

const checkOnChange = (e:any, row:any) => {
	// 多选
	if (multiple.value) {
		row.checked = e
		if (e) {
			selectList.value.push(row)
		} else {
			selectList.value.map((item:any, index:any) => {
				if (item.code === row.code) {
					selectList.value.splice(index, 1)
				}
			})
		}
	} else {
		selectList.value = []
		cardList.value.map((item:any) => {
			if (row.id === item.id) {
				item.checked = true
				selectList.value.push(item)
			} else {
				item.checked = false
			}
		})
	}
}
const onInput = debounce(function () {
	searchForm.value = {
		...searchForm.value,
		pageNo: 1,
	}
	searchData()
}, 500)

const cascaderArr:any = ref(null)
const provinceChange = (e:any) => {
	const checkedNode = cascaderArr.value.getCheckedNodes()
	searchForm.value = {
		...searchForm.value,
		cityCode: (!e || e.length === 0 )? "" : checkedNode[0].pathValues[1],
		cityName: (!e || e.length === 0 )? "" : checkedNode[0].pathLabels[1],
		provinceCode: (!e || e.length === 0 )? "" : checkedNode[0].pathValues[0],
		provinceName: (!e || e.length === 0 )? "" : checkedNode[0].pathLabels[0],
		pageNo: 1,
	}
	searchData()
}

const classHandleChange = (e:any) => {
	searchForm.value = {
		...searchForm.value,
		supplierClassify: e,
		pageNo: 1,
	}
	searchData()
}

const submitHandleClick = () => {
	emit("confirm", selectList.value)
}


const getPersonalData = async () => {
	loading.value = true
	const res:any = await queryPerSupplierList(searchForm.value)
	if (res.msgCode === "100") {
		const responseData = res.responseData.list
		searchForm.value.totalPages = res.responseData.totalPages
		if (responseData.length !== 0) {
			responseData.map((item:any) => {
				cardList.value.push(item)
			})
			cardList.value.map((item:any) => {
				item.checked = selectList.value.filter((childItem:any) => childItem.id === item.id).length === 0 ? false : true
			})
			noMore.value = false
		} else {
			noMore.value = true
		}
	} else {
		noMore.value = true
	}
	loading.value = false
}

const getEnterpriseData = async () => {
	loading.value = true
	const res:any = await getSupplierList(searchForm.value)
	if (res.msgCode === "100") {
		const responseData = res.responseData.resultList.map((item:any) => {
			return {
				...item,
				id: item.supplierId
			}
		})
		searchForm.value.totalPages = res.responseData.total
		if (responseData.length !== 0) {
			responseData.map((item:any) => {
				item.checked = selectList.value.filter((childItem:any) => childItem.id === item.id).length === 0 ? false : true
				cardList.value.push(item)
			})
			noMore.value = false
		} else {
			noMore.value = true
		}
	} else {
		noMore.value = true
	}
	loading.value = false
}

const getAreaListData = async () => {
	const res:any = await getAreaList()
	if (res.msgCode === "100") {
		let data = res.responseData
		data.map((item:any) => {
			item.list.map((childItem:any) => {
				delete childItem.list
			})
		})
		areaList.value = data
	}
}

const getClientInitData = async () => {
	const res:any = await getClientInit()
	if (res.msgCode === "100") {
		supplierClassifyList.value = res.responseData.companyDictionary.supplierClassifyList
	}
}

const closeSelector = () => {
	// @ts-ignore
	emit("update:modelValue", false)
}

defineOptions({
	name: "TqSupplierSelector"
})
</script>